import _ from "lodash";
import {
  GamePositionColor,
  Player,
  PlayerDetails,
  Position,
} from "../../types/Game";
import { Content } from "../../types/Types";
import BoardPosition from "./BoardPosition";
import LocalStoreageService from "../../services/LocalStorage";
import ContentService from "./../../services/Content";

const createPlayers = (profiles: Array<PlayerDetails>): Array<Player> => {
  const players: Array<Player> = [];
  profiles.map((profile, index) => {
    const currentPosition = BoardPosition.get(profile.boardPosition);
    const initialPosition = BoardPosition.getStart(index);
    if (currentPosition && initialPosition) {
      players.push({
        profile,
        position:
          profile.boardPosition <= 0 ? initialPosition : currentPosition,
        spriteId: index,
      });
    }
  });
  return players;
};

const updatePlayerPosition = (player: Player, position: Position): boolean => {
  const players = LocalStoreageService.getGamePlayers();
  let found = false;
  if (players) {
    const playersUpdate = players.map((playerItem) => {
      if (player.profile.userId === playerItem.profile.userId) {
        found = true;
        return { ...playerItem, position };
      } else {
        return playerItem;
      }
    });

    if (found) {
      LocalStoreageService.saveGamePlayers(playersUpdate);
    }
  }

  return found;
};

const getPlayerBySpriteId = (
  spriteId: number,
  players: Player[]
): Player | null => {
  const player = _.find(
    players,
    (player: Player) => player.spriteId === spriteId
  );
  return player || null;
};

const getRandomCard = async (content: Content[], color: GamePositionColor) => {

  const allCards = content.filter((item) => _.isEqual(item.type, color));
  const type = allCards[0].type;
  const currentCard = await ContentService.getCurrentCard(type || "");
  const cards = await ContentService.getRandomCards(type);
  
  const card = await  ContentService.getNextCard(
    currentCard as string,
    cards as Content[]
  );
  if(!card){
    throw Error("Random card does not exits")
  }
  await ContentService.saveCurrentCard(card.id, type);
  return card;
};

export default {
  createPlayers,
  updatePlayerPosition,
  getPlayerBySpriteId,
  getRandomCard,
};
